import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "left-filter-section" };
const _hoisted_2 = { class: "brg-input-section multi-date-picker-activator" };
const _hoisted_3 = { class: "brg-color-grey-600 text-subtitle-2" };
const _hoisted_4 = { class: "right-filter-section" };
import { ref, onMounted, } from 'vue';
import { format, endOfMonth, subMonths, } from 'date-fns';
import vuexStore from '@/vuex-store';
import SubControllerTemplate from '@/templates/SubControllerTemplate.vue';
import { autoLcBaromoneyTransferSetting } from '@/locales/ko/views/baromoney-transfer-setting';
import { pageSizeOptionList } from '@/constants';
import { pStore } from '@/pinia';
import { storeToRefs } from 'pinia';
import { prevData } from '@/pinia/baromoneyTransferSetting';
import dateFormatType from '@/constants/dateFormatType';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { keywordTypeOptionList, statusOptionList, searchTypeOptionList, } from '@/constants/baromoneyTransferSetting/baromoneytransfersettingList';
import Select from '@/components/Form/Select.vue';
import SearchInput from '@/components/Form/SearchInput.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SubController',
    setup(__props) {
        const lc = autoLcBaromoneyTransferSetting();
        const pBaromoneyTransferSetting = pStore.piniaBaromoneyTransferSetting;
        const { filterOption, } = storeToRefs(pBaromoneyTransferSetting);
        // 초기 index 0으로 설정
        const searchFieldType = ref(keywordTypeOptionList[0]?.value || 0);
        const searchQuery = ref('');
        const searchUseType = ref(String(statusOptionList[1]?.value || 'USE'));
        const searchViewsType = ref(searchTypeOptionList[0]?.value || 0);
        const selectedPeriod = ref([]);
        const selectedPeriodFormat = dateFormatType.DATE;
        const today = ref(new Date());
        const maxDate = ref(format(endOfMonth(today.value), selectedPeriodFormat));
        /**
         * 날짜를 설정한다.
         * selectedPeriod, prevData, filterOption 일괄 셋팅한다.
         */
        const setInitializeDate = (startDate, endDate) => {
            // text input 에서 보여지는 날짜
            selectedPeriod.value = [
                startDate,
                endDate,
            ];
            // 페이지 이동시 백업을 위한 값
            prevData.fromDate = startDate;
            prevData.toDate = endDate;
            // api에서 사용되는 값
            filterOption.value.fromDate = startDate;
            filterOption.value.toDate = endDate;
        };
        /**
         * 초기화 버튼 클릭 핸들러
         */
        const handleClickResetButton = () => {
            searchFieldType.value = keywordTypeOptionList[0]?.value || 0;
            searchQuery.value = '';
            searchUseType.value = statusOptionList[1]?.value || 'USE';
            searchViewsType.value = searchTypeOptionList[0]?.value || 0;
            filterOption.value.pageNumber = 1;
            filterOption.value.pageSizeType = pageSizeOptionList[0]?.value || 20;
            prevData.pageSizeType = filterOption.value.pageSizeType;
            setInitializeDate(format(subMonths(today.value, 1), selectedPeriodFormat), format(endOfMonth(today.value), selectedPeriodFormat));
            // Pinia store 상태 업데이트
            pBaromoneyTransferSetting.updateFilterOption({
                searchType: searchFieldType.value,
                searchText: searchQuery.value,
                useType: searchUseType.value,
                ViewsType: searchViewsType.value,
                fromDate: prevData.fromDate,
                toDate: prevData.toDate,
            });
        };
        /**
         * 검색 버튼 클릭 핸들러
         */
        const handleSearchBtnClick = async (value) => {
            setInitializeDate(filterOption.value.fromDate, filterOption.value.toDate);
            // Pinia 상태 업데이트 또는 검색 API 호출
            await pBaromoneyTransferSetting.updateFilterOption({
                searchText: value,
            });
            // 검색 실행
            pBaromoneyTransferSetting.getItemList();
        };
        /**
         * 필터(사용여부, 조회기준, 페이지) 변경 핸들러
         */
        const handleChangeSelect = (filterType) => async (value) => {
            const oldPageNumber = filterOption.value.pageNumber;
            try {
                // 필터 타입에 따른 상태 업데이트
                const updateData = {
                    pageNumber: 1,
                };
                switch (filterType) {
                    case 'useType':
                        updateData.useType = value;
                        searchUseType.value = value;
                        break;
                    case 'ViewsType':
                        updateData.ViewsType = value;
                        searchViewsType.value = value;
                        break;
                    case 'pageSizeType':
                        updateData.pageSizeType = value;
                        prevData.pageSizeType = value;
                        break;
                    default:
                        if (Object.hasOwn(filterOption.value, filterType)) {
                            updateData[filterType] = value;
                        }
                }
                // Pinia store 업데이트
                await pBaromoneyTransferSetting.updateFilterOption(updateData);
            }
            catch (error) {
                console.log('baromoneyTransferSetting/handleChangeSelect', error);
                vuexStore.dispatch(snackbarActionType.showError);
                filterOption.value.pageNumber = oldPageNumber;
            }
        };
        // 키워드검색 셀렉트 변경 시 핸들러
        const handleChangFieldType = (fieldType) => {
            searchFieldType.value = fieldType;
            pBaromoneyTransferSetting.updateFilterOption({
                searchType: searchFieldType.value,
            });
        };
        /**
         * 기준일 선택 시 핸들러
         */
        const handleChangePeriodSelector = (value) => {
            selectedPeriod.value = [
                value[0],
                value[0],
            ];
            // 하루만 선택 시 에외 처리
            if (value[1]) {
                // eslint-disable-next-line prefer-destructuring
                selectedPeriod.value[1] = value[1];
            }
            pBaromoneyTransferSetting.updateFilterOption({
                fromDate: selectedPeriod.value[0],
                toDate: selectedPeriod.value[1],
            });
        };
        onMounted(async () => {
            // 최초 마운트시에는 prevData 혹은 오늘 날짜로 한다.
            setInitializeDate(prevData.fromDate ? prevData.fromDate : format(subMonths(today.value, 1), selectedPeriodFormat), prevData.toDate ? prevData.toDate : format(endOfMonth(today.value), selectedPeriodFormat));
            try {
                if (prevData.pageNumber) {
                    filterOption.value.pageNumber = prevData.pageNumber;
                    prevData.pageNumber = 0;
                }
                if (prevData.pageSizeType) {
                    filterOption.value.pageSizeType = prevData.pageSizeType;
                    prevData.pageSizeType = '';
                }
                await pBaromoneyTransferSetting.getItemList();
            }
            catch (error) {
                console.log('error', error);
                // 에러 메시지를 안전하게 추출
                const errorMessage = error?.data?.error || error?.message || '알 수 없는 에러가 발생했습니다.';
                vuexStore.dispatch(snackbarActionType.showError, errorMessage);
            }
        });
        return (_ctx, _cache) => {
            const _component_vue_datepicker_action_row = _resolveComponent("vue-datepicker-action-row");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_vue_datepicker = _resolveComponent("vue-datepicker");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createBlock(SubControllerTemplate, null, {
                toolsSlot: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createCommentVNode(" 조회 기간 "),
                        _createElementVNode("div", null, [
                            _createVNode(_component_vue_datepicker, {
                                modelValue: selectedPeriod.value,
                                "onUpdate:modelValue": [
                                    _cache[0] || (_cache[0] = ($event) => ((selectedPeriod).value = $event)),
                                    handleChangePeriodSelector
                                ],
                                range: "",
                                position: "left",
                                format: _unref(selectedPeriodFormat),
                                "model-type": _unref(selectedPeriodFormat),
                                "max-date": maxDate.value
                            }, {
                                "action-row": _withCtx((props) => [
                                    _createVNode(_component_vue_datepicker_action_row, _normalizeProps(_guardReactiveProps(props)), null, 16 /* FULL_PROPS */)
                                ]),
                                "dp-input": _withCtx(() => [
                                    _createElementVNode("div", _hoisted_2, [
                                        _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(lc)('created_name')), 1 /* TEXT */),
                                        _createVNode(_component_v_text_field, {
                                            value: `${selectedPeriod.value[0]} ~ ${selectedPeriod.value[1]}`,
                                            variant: "outlined",
                                            density: "compact",
                                            readonly: "",
                                            "hide-details": "",
                                            class: "mt-2",
                                            "bg-color": "white",
                                            "prepend-inner-icon": "mdi-calendar-month-outline"
                                        }, null, 8 /* PROPS */, ["value"])
                                    ])
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue", "format", "model-type", "max-date"])
                        ]),
                        _createCommentVNode(" 사용여부 "),
                        _createVNode(Select, {
                            class: "status-wrapper",
                            width: 108,
                            title: _unref(lc)('status_tltle'),
                            value: searchUseType.value,
                            items: _unref(statusOptionList),
                            "on-change": handleChangeSelect('useType')
                        }, null, 8 /* PROPS */, ["title", "value", "items", "on-change"]),
                        _createCommentVNode(" 조회기준 "),
                        _createVNode(Select, {
                            class: "search-type-wrapper",
                            width: 108,
                            title: _unref(lc)('search_type'),
                            value: searchViewsType.value,
                            items: _unref(searchTypeOptionList),
                            "on-change": handleChangeSelect('ViewsType')
                        }, null, 8 /* PROPS */, ["title", "value", "items", "on-change"]),
                        _createCommentVNode(" 키워드 검색 "),
                        _createVNode(Select, {
                            class: "keyword-search-wrapper",
                            width: 140,
                            title: _unref(lc)('keyword_search'),
                            items: _unref(keywordTypeOptionList),
                            value: searchFieldType.value,
                            "on-change": handleChangFieldType
                        }, null, 8 /* PROPS */, ["title", "items", "value"]),
                        _createVNode(SearchInput, {
                            outlined: "",
                            width: 300,
                            placeholder: _ctx.$t('common.input_field_placeholder', { field: _ctx.$t('common.search_word') }),
                            "on-search": handleSearchBtnClick
                        }, {
                            btnText: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                                        _createTextVNode("mdi-magnify")
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [1]
                                }),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.search')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["placeholder"]),
                        _createCommentVNode(" 초기화 버튼 "),
                        _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                            onClick: handleClickResetButton,
                            class: "ml-4"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_icon, { size: "16" }, {
                                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                                        _createTextVNode(" mdi-restart ")
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [2]
                                }),
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.reset')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        })), [
                            [
                                _directive_btn_style,
                                void 0,
                                "config",
                                {
                                    info: true,
                                    "size-l": true,
                                    outlined: true
                                }
                            ]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createCommentVNode(" paleSize filter "),
                        _createVNode(Select, {
                            class: "page-size-wrapper",
                            width: 95,
                            value: _unref(filterOption).pageSizeType,
                            items: _unref(pageSizeOptionList),
                            "on-change": handleChangeSelect('pageSizeType')
                        }, null, 8 /* PROPS */, ["value", "items", "on-change"])
                    ])
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
